import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from '@general/colors';
import fonts from '@general/fonts';

const BaseStyled = styled.button`
    background-color: ${props => (props.active ? colors.azure : colors.ultraLightGray)};
    border: none;
    color: ${props => (props.active ? '#fff' : '#000')};
    cursor: pointer;
    font-family: ${fonts.sans};
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 14px;
    padding: 7px 14px;
`;

const LeftStyled = styled(BaseStyled)`
    border-bottom-left-radius: 24px;
    border-top-left-radius: 24px;
`;

const RightStyled = styled(BaseStyled)`
    border-bottom-right-radius: 24px;
    border-top-right-radius: 24px;
`;

const PillToggle = ({ activeInitial = 'left', leftLabel, rightLabel, onLeftClick, onRightClick }) => {
    const [activeSide, setActiveSide] = useState(activeInitial);

    return (
        <div>
            <LeftStyled
                type="button"
                active={activeSide === 'left'}
                onClick={() => {
                    setActiveSide('left');
                    onLeftClick();
                }}
            >
                {leftLabel}
            </LeftStyled>

            <RightStyled
                type="button"
                active={activeSide === 'right'}
                onClick={() => {
                    setActiveSide('right');
                    onRightClick();
                }}
            >
                {rightLabel}
            </RightStyled>
        </div>
    );
};

PillToggle.propTypes = {
    activeInitial: PropTypes.oneOf(['left', 'right']),
    leftLabel: PropTypes.string.isRequired,
    rightLabel: PropTypes.string.isRequired,
    onLeftClick: PropTypes.func.isRequired,
    onRightClick: PropTypes.func.isRequired,
};

export default PillToggle;
